$(document).ready(function () {
    rowsCount = {};
    closeClick = true;

    var main = {
        originalDate: [],
        menubarMinWidth: $('#menubar').css('min-width'),
        loading: $('<div id="loading">Загружаем…</div>')
    };

    $(document).ajaxStart(function () {
        $('#content-container').append(main.loading);
    }).ajaxStop(function () {
        main.loading.detach();
    });

    main.messageShow = function (type, message) {
        type = type || 'error';
        message = $('<table class="message message-' + type + '" cellpadding="0" cellspacing="0"><tr><td /><td>' + message + '</td></tr></table>');

        var $messages = $('#messages');
        if (0 == $messages.length) {
            $('#content-wrapper').append('<div id="messages" />');
        }

        $messages.append(message).find(message).hide().fadeIn('slow');

        setTimeout(function () {
            $(message).fadeOut('slow', function () {
                $(this).remove();
            });
        }, 5000);
    };

    window.calendarButtonsWidth = function calendarButtonsWidth() {
        $('#calendar').find('.header .buttons').width($('#calendar table td').width());
    };

    main.tableFixedHead = function () {
        $('table.list').each(function (i, el) {
            var defered = $.Deferred();

            defered.done(function () {
                $('thead', el).css({position: 'relative', height: 'auto', width: 'auto'});
                $('tbody tr:first-of-type td, thead th', el).css('minWidth', '');
            }, function () {
                $('tbody tr:first-of-type td, thead th', el).each(function () {
                    $(this).css({minWidth: $(this).innerWidth()});
                });

                $(el).find('thead').css({
                    position: 'fixed',
                    zIndex: 1000,
                    height: $(el).find('thead').height(),
                    width: $(el).find('thead').outerWidth() + 2
                });

                $(el).css({top: $(el).find('thead').height()});
            }).resolve();
        });
    };

    main.newInlineRow = function () {
        var $button = $(this);
        var type = $button.data('type');

        //правка структуры прототипа для новых рядов
        if ($button.prevAll('[data-prototype]').length > 0) {
            var $div = $button.prevAll('[data-prototype]');
            var prot = $($div.data('prototype')).html();
            // .data() не отрабатывает, баг jquery?
            $button.parent().attr('data-prototype-' + type, prot);
            $div.detach();
        }

        var newRow = $(this).parent().data('prototype-' + type);
        var rowNum = $(this).prevAll('div').length;

        if (newRow) {
            newRow = $(newRow.replace(/__inline__/g, rowNum));

            if (rowNum > 0) {
                $button.before('<a class="inline-remove">×</a>');
            }

            $button.before(newRow);

            makeRadiosCheckboxesAndSelectsBeautiful();
        }
    };

    main.removeInlineRow = function () {
        var $el = $(this);
        $el.prev('div').detach();
        $el.detach();
    };

    main.newRow = function () {

    };

    var $clients = $("#clients");

    $clients.on('click', 'tbody,#clients-new', function (e) {
        var el = e.target;
        if ($(el).attr('type') === 'checkbox') {
            e.preventDefault();

            return;
        }

        if ($(el).hasClass('merge') || $(el).parent().hasClass('merge')) {
            return;
        }
    });

    $clients.on('click', 'tbody tr a', function (e) {
        e.stopPropagation();
    });

    $clients.on('click', 'tbody tr', function (e) {
        e.preventDefault();

        window.open($(this).data('url'), '_blank');
    });

    $clients.on('click', 'index', function (e) {
        e.stopPropagation();
    });

    $clients.on('click', "tbody img.days-left-edit",function (e) {
        e.stopPropagation();

        var daysEditClickHandler = function (e) {
            e.stopPropagation();
            e.preventDefault();
        };

        var $editIcon = $(this);
        console.log($editIcon, $editIcon.prev(), $editIcon.prev().text());
        var days = $editIcon.prev().text();
        $editIcon
            .prev()
            .replaceWith('<input>');

        $editIcon.prev().val(days);

        $editIcon
            .prev()
            .on('click', daysEditClickHandler)
            .on('keyup', function(e) {
                if (e.keyCode == 13) { //Enter
                    days = $editIcon.prev().val();
                    $editIcon.prev().replaceWith('<span>');
                    $editIcon.prev().text(days);
                    $.post($editIcon.data('change-url'), {'days': days});
                } else if (e.keyCode == 27) { //Escape
                    $editIcon.prev().replaceWith('<span>');
                    $editIcon.prev().text(days);
                }
            });
    });

    $clients.on('click', 'tbody tr .deactivate, tbody tr .delete', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $el = $(this);
        var message, address;

        var id = $el.closest('tr').attr('id');
        var parent = $el.closest('tr');

        if (!id) {
            id = 'create';
        }

        if ($el.hasClass('deactivate')) {
            message = 'Деактивировать этого клиента?';
            address = '/clients/deactivate/' + id;
        } else {
            if ($el.hasClass('closed')) {
                message = 'Пененести заведение в активные?';
            } else {
                message = 'Пененести заведение в закрытые?';
            }

            address = '/clients/close/' + id;
        }

        if (confirm(message)) {
            $.post(address, function (data) {
                if (data.length > 0) {
                    main.messageShow('error', 'В процессе ' + ($el.hasClass('deactivate') ? 'деактивации' : 'удаления') + ' клиента произошла ошибка');
                } else {
                    main.messageShow(($el.hasClass('deactivate') ? 'deactivate' : 'delete'), 'Клиент был ' + ($el.hasClass('deactivate') ? 'переведен в неактивные' : 'перенесен в закрытые'));

                    $(parent).fadeOut('slow', function () {
                        $(this).remove();
                    })
                }
            });
        }
    });

    $('#viewport-center').on('click', function (e, fast) {
        var fast = fast || false;
        var date = new Date, cookie, left = '=' + $('#viewport-left').width();

        if (!$(this).hasClass('clicked')) {
            left = '-' + left;
            cookie = 0;

            $(this).addClass('clicked');
        } else {
            left = '+' + left;
            cookie = 1;

            $(this).removeClass('clicked');
        }

        setCookie('menubar', cookie, date.setDate(date.getDate() + 365), '/');

        if (fast) {
            $('#viewport-left,#viewport-center,#viewport-right,#viewport-sidebar').css({left: left});
        } else {
            $('#viewport-left,#viewport-center,#viewport-right,#viewport-sidebar').animate({left: left}, 1000, main.tableFixedHead);
        }
    });

    $('#menubar a+a').prev('a').children('span').css({marginRight: 31});

    $(document).on('click', '[id^="task-plus-"]', function () {
        if (!main.originalDate.length) {
            main.originalDate[0] = $('#task_happenAt_date_year').val();
            main.originalDate[1] = $('#task_happenAt_date_month').val() - 1;
            main.originalDate[2] = $('#task_happenAt_date_day').val();
        }

        var date = new Date(main.originalDate[0], main.originalDate[1], main.originalDate[2]);

        date.setDate(date.getDate() + parseInt($(this).attr('id').split(/-/).slice(-1)));

        while (0 == date.getDay() || 6 == date.getDay()) {
            date.setDate(date.getDate() + 1);
        }

        var newYear = date.getFullYear(), newMonth = (date.getMonth() + 1), newDay = date.getDate();

        $('#task_happenAt_date_year').val(newYear).trigger('change');
        $('#task_happenAt_date_month').val(newMonth).trigger('change');
        $('#task_happenAt_date_day').val(newDay).trigger('change');
    });

    main.tableFixedHead();
    calendarButtonsWidth();
    makeRadiosCheckboxesAndSelectsBeautiful();

    if (0 == getCookie('menubar')) {
        $('#viewport-center').trigger('click', true);
    }

    $('#menubar a[href="' + window.location.pathname + '"]').addClass('current');

    if ($('table.infinite')) {
        $('#content-wrapper').on('scroll', function () {
            if ($('table.infinite tr:last').is(':in-viewport') && !$('#loading').is(':visible')) {
                $.get($('table.infinite').data('href'), {offset: $('table.infinite tbody tr').length}, function (data) {
                    $('table.infinite tr:last').after(data);

                    main.tableFixedHead();
                    makeRadiosCheckboxesAndSelectsBeautiful();
                });
            }
        });
    }

    $(window).on('resize', function () {
        main.tableFixedHead();
        calendarButtonsWidth();
    });

    // Фикс отрисовки таблицы списка клиентов с фиксированным заголовком
    main.tableFixedHead();

    $("#select_all").on('change', function () {
        var checked = $(this).is(':checked');
        $(':checkbox')
            .filter('[name^="merge"]')
            .prop('checked', checked)
            .trigger('change')
            .parent('div')
            .toggleClass('checked', checked);
    });

    var $errorsDiv = $('#form-errors');

    $errorsDiv.dialog({
        autoOpen: false,
        width: "auto",
        minWidth: 600,
        maxWidth: '75%'
    });

    $('#users tbody,#users-new').on('click', function (e) {
        var el = e.target;
        var id = $(el).closest('tr').attr('id');

        if (!id) {
            id = 'create';
        }

        $.get(Routing.generate("user.show", {id: id}), function (data) {
            $("#users-dialog")
                .html(data)
                .dialog({
                    modal:true,
                    width: 800,
                    height:600,
                    zIndex:200,
                    buttons: [
                        {
                            text: "Сохранить",
                            type: "submit",
                            icons: {
                                primary: "ui-icon-disk"
                            },
                            click: function() {
                                var form = $(this).find('form');
                                var data = new FormData(form[0]);

                                $.ajax({
                                    url: "create" === id ? Routing.generate("user.create") : Routing.generate("user.edit", {id: id}),
                                    type: 'POST',
                                    data: data,
                                    success: function (data) {
                                        if (data.length == 0) {
                                            let successMessage = '<h1>Пользователь сохранен</h1>';

                                            if ("create" === id) {
                                                successMessage = '<h1>Пользователь сохранен</h1>' +
                                                    '<span>Ссылка для активации учётной записи была отправлена на почту</span>'
                                            }

                                            $("#users-dialog").html(successMessage);
                                        } else {
                                            form.replaceWith($(data).find('form'));
                                            $('#user_rolesCollection').select2({width: '100%'});
                                        }
                                    },
                                    cache: false,
                                    contentType: false,
                                    processData: false
                                });
                            }
                        },
                        {
                            text: "Закрыть",
                            icons: {
                                primary: "ui-icon-close"
                            },
                            click: function() {
                                $(this).dialog('close');
                            }
                        }
                    ]
                });
        });

        return false;
    });

    $("#newsletter-window button.mail-received").on('click', function(e) {
        e.preventDefault();

        var $el = $(this);
        var url = $el.data('update-url');
        $.post(url, {}, function(data) {
            if (data.success) {
                $el.parent().prevAll('td.color').css('background-color', 'blue');
                $el.hide();
            }
        });
    });

    $('body').on('change', '#comment_action input', function() {
        var $el = $(this);

        var $commentHappenAt = $("#comment_happenAt_wrapper");
        if ($el.val() == 6) { // Перенос
            $commentHappenAt.show();
        } else {
            $commentHappenAt.hide();
        }
    });

    var $siteLink = $("#site_link"),
        $siteUrl = $("#site_url");

    $siteLink.click(function (event) {

        $siteUrl.toggle();

        event.preventDefault();
    });

    $siteUrl
        .add($siteLink)
        .find("input").keypress(function (event) {

        if (event.which == 13) {
            event.preventDefault();

            $(this).parent().hide();

        }

    });

    $("#eff-print-all").on('click', function (e) {
        e.preventDefault();
        $(this).next('div.wrap').print();
    });

    // slide-down блок
    function slideDownBoxToggle({
                                    box,
                                    btn,
                                    activeBtnClass = {active: '', default: ''},
                                    minHeight = false,
                                }) {
        const firstHeightBox = box.clientHeight;
        const fullHeightBox  = box.scrollHeight;
        const btnFirstTxt    = btn.textContent;

        if(fullHeightBox === firstHeightBox) {
            btn.parentNode.style.cssText = 'display:none !important';
            box.style.height = 'auto';
            box.style.overflow = 'inherit';
            box.classList.remove('_border-bottom');

            if(minHeight) {
                box.style.minHeight = 'auto';
            }
        }

        btn.addEventListener('click', () => {
            let fullHeightBox  = box.scrollHeight;
            if(box.classList.contains('_active')) {
                // закрыть таблицу
                box.classList.remove('_active');
                box.style.height = firstHeightBox + 'px';
                btn.classList.add(activeBtnClass.active);
                btn.classList.remove(activeBtnClass.default);
                btn.textContent = btnFirstTxt;

                if(minHeight) {
                    box.style.minHeight = firstHeightBox + 'px';
                }
            } else {
                // открыть таблицу
                box.classList.add('_active');
                box.style.height = fullHeightBox + 'px';
                btn.classList.add(activeBtnClass.default);
                btn.classList.remove(activeBtnClass.active);
                btn.textContent = 'Скрыть';

                if(minHeight) {
                    box.style.minHeight = fullHeightBox + 'px';
                }
            }
        })
    }
    // end

    // открыть/закрыть таблицу "что покупали"
    const boughtPastTable = document.querySelector('[data-box="bought-past-table"]');
    const boughtPastBtn   = document.querySelector('[data-btn="bought-past"]');
    if(boughtPastTable && boughtPastBtn) {
        slideDownBoxToggle({
            box: boughtPastTable,
            btn: boughtPastBtn,
            activeBtnClass: {active: 'btn-activity', default: 'btn-task'},
            minHeight: true
        });
    }
    // end

    // открыть/закрыть таблицу "что покупали" (раздел "расчеты")
    const boughtPastCalcTable = document.querySelector('[data-box="bought-past-table_calc"]');
    const boughtPastCalcBtn   = document.querySelector('[data-btn="bought-past_calc"]');
    if(boughtPastCalcTable && boughtPastCalcBtn) {
        slideDownBoxToggle({
            box: boughtPastCalcTable,
            btn: boughtPastCalcBtn,
            activeBtnClass: {active: 'btn-activity', default: 'btn-task'},
            minHeight: true
        });
    }
    // end

    // открыть/закрыть таблицу "все платежи" (раздел "расчеты")
    const allPaymentsTable = document.querySelector('[data-box="all-payments"]');
    const allPaymentsBtn   = document.querySelector('[data-btn="all-payments"]');
    if(allPaymentsTable && allPaymentsBtn) {
        slideDownBoxToggle({
            box: allPaymentsTable,
            btn: allPaymentsBtn,
            activeBtnClass: {active: 'btn-activity', default: 'btn-task'}
        });
    }
    // end

    // открыть/закрыть таблицу "остатки по счетам" (раздел "расчеты")
    const accountBalancesTable = document.querySelector('[data-box="account-balances"]');
    const accountBalancesBtn   = document.querySelector('[data-btn="account-balances"]');
    if(accountBalancesTable && accountBalancesBtn) {
        slideDownBoxToggle({
            box: accountBalancesTable,
            btn: accountBalancesBtn,
            activeBtnClass: {active: 'btn-activity', default: 'btn-task'}
        });
    }
    // end

});